/**
 * Calling-settings context type. Set via the shared useContextDrawer().setContext()
 * — there is only one context manager for the entire drawer. Opening Calling
 * Settings on the human-dialer page mounts DialerSettingsContextPanel in the docked
 * right column (mirrors how an integration opens IntegrationsContextPanel and a
 * canvas node opens SalesPlayContextPanel).
 */

import type { TelephonySurface } from './useTelephony'

export const DIALER_SETTINGS_CONTEXT_TYPE = 'dialer_settings' as const

export interface DialerSettingsContext {
  type: typeof DIALER_SETTINGS_CONTEXT_TYPE
  /**
   * Which surface to open to (deep-link / gear target). This is only a seed on
   * open — useTelephony.activeSurface remains the source of truth for the body,
   * so in-panel navigation doesn't churn the context (and dodge its debounce).
   */
  surface?: TelephonySurface
}
